/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiComponentBlockFromJSON, ApiComponentBlockToJSON, } from './ApiComponentBlock';
export function ApiComponentAIBlockEditorPayloadFromJSON(json) {
    return ApiComponentAIBlockEditorPayloadFromJSONTyped(json, false);
}
export function ApiComponentAIBlockEditorPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'block': !exists(json, 'block') ? undefined : ApiComponentBlockFromJSON(json['block']),
        'prompt': !exists(json, 'prompt') ? undefined : json['prompt'],
    };
}
export function ApiComponentAIBlockEditorPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'block': ApiComponentBlockToJSON(value.block),
        'prompt': value.prompt,
    };
}
